
import { ProfileData } from "@/types/profile";
import { useProfileFormHandlers } from "./profile";

/**
 * Main hook for profile form handling with reliable auto-save
 * This is a wrapper around more specialized hooks for better organization
 */
export const useProfileForm = (
  profile: ProfileData,
  setProfile: React.Dispatch<React.SetStateAction<ProfileData>>,
  setUploading: (uploading: boolean) => void
) => {
  // Use our specialized hook for form handlers
  return useProfileFormHandlers(profile, setProfile, setUploading);
};
